if (!customElements.get('sanalio-faq')) {
  customElements.define('sanalio-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.items = [...this.querySelectorAll('.snlfq-messages > .snlfq-item')];
      this.filters = [...this.querySelectorAll('[data-faq-filter]')];
      this.filters.forEach(button => {
        button.hidden = !this.items.some(item => item.dataset.faqCategory === button.dataset.faqFilter);
        button.addEventListener('click', () => this.selectCategory(button.dataset.faqFilter), { signal });
      });
      const first = this.filters.find(button => !button.hidden);
      const topics = this.querySelector('.snlfq-topics');
      if (topics && first) {
        topics.hidden = false;
        this.selectCategory(first.dataset.faqFilter);
      }
      if (!first || !topics) this.items.forEach((item, index) => { item.querySelector('.snlfq-detail').open = this.dataset.first === 'true' && index === 0; });
      this.addEventListener('toggle', event => {
        if (!event.target.matches('.snlfq-detail') || !event.target.open || this.dataset.single !== 'true') return;
        this.items.forEach(item => {
          const details = item.querySelector('.snlfq-detail');
          if (details !== event.target) details.open = false;
        });
      }, { capture: true, signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.contains(event.target) || this.dataset.first === 'true') return;
        event.target.closest('.snlfq-item')?.querySelector('.snlfq-detail')?.removeAttribute('open');
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('.snlfq-item');
        if (!item) return;
        if (first) this.selectCategory(item.dataset.faqCategory, false);
        const details = item.querySelector('.snlfq-detail');
        details.open = true;
        item.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }, { signal });
    }
    selectCategory(category, openFirst = true) {
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqFilter === category)));
      this.items.forEach(item => {
        item.hidden = item.dataset.faqCategory !== category;
        item.querySelector('.snlfq-detail').open = false;
      });
      if (openFirst && this.dataset.first === 'true') {
        const first = this.items.find(item => !item.hidden);
        if (first) first.querySelector('.snlfq-detail').open = true;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

